/**
 * 令牌缓存Key
 */
export const TOKEN_KEY = "accessToken";

/**
 * 题库令牌缓存Key
 */
export const QB_TOKEN_KEY = "questionBankAccessToken";
